module.exports = __webpack_public_path__ + "img/map.c45c0415.jpg";